module.exports = __webpack_public_path__ + "img/Spirodela_polyrhiza.43077218.jpg";